import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "step-title-container"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "form-content" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "selects-container" }
const _hoisted_6 = { class: "form-group form-group-select-mobile" }
const _hoisted_7 = { class: "input-wr" }
const _hoisted_8 = { class: "dropdown-button input-dropdown" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "form-group form-group-select-mobile" }
const _hoisted_11 = { class: "input-wr" }
const _hoisted_12 = { class: "dropdown-button input-dropdown" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "left-container"
}
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page-wr", { mobile: !$setup.isDesktop }])
  }, [
    (!$setup.isDesktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode($setup["BuilderEstimatorStepTitle"], { title: "Land Details" })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["right-container", { mobile: !$setup.isDesktop }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "title" }, "Tell us about your preferred build location and lot preferences to help us better understand your build requirements.")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createElementVNode("label", { for: "preferredLocation" }, "Preferred build location", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.preferredLocation) = $event)),
              placeholder: "Type estate / suburb"
            }, null, 512), [
              [_vModelText, $setup.preferredLocation]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[2] || (_cache[2] = _createElementVNode("label", { for: "landWidth" }, "Land width", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createVNode($setup["DropDown"], null, {
                  control: _withCtx(() => [
                    _createElementVNode("label", _hoisted_8, _toDisplayString($setup.landWidth || "Select"), 1)
                  ]),
                  dropdown: _withCtx(() => [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(['Any', ...$setup.LAND_WIDTH_OPTIONS], (option) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: option,
                          onClick: ($event: any) => ($setup.updateLandDimension('width', option))
                        }, _toDisplayString(option), 9, _hoisted_9))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[3] || (_cache[3] = _createElementVNode("label", { for: "landDepth" }, "Land depth", -1)),
              _createElementVNode("div", _hoisted_11, [
                _createVNode($setup["DropDown"], null, {
                  control: _withCtx(() => [
                    _createElementVNode("label", _hoisted_12, _toDisplayString($setup.landDepth || "Select"), 1)
                  ]),
                  dropdown: _withCtx(() => [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(['Any', ...$setup.LAND_DEEP_OPTIONS], (option) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: option,
                          onClick: ($event: any) => ($setup.updateLandDimension('depth', option))
                        }, _toDisplayString(option), 9, _hoisted_13))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ], 2),
    ($setup.isDesktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("img", {
            class: "logo",
            src: $setup.props.builderLogo
          }, null, 8, _hoisted_15)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}